/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { decode } from '@codegrade/utils';
export default decode.buffer;
